import React, { useState, CSSProperties } from 'react';
import { Formik } from 'formik';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

import { passwordResetSchema } from '../utils';
import { Colors, auth } from '../config2';
import { View, TextInput, Button2 as Button, FormErrorMessage } from '../components';
import { en, es } from '../localizations';

const i18n = {
  t: (key: string) => {
    const translations = es as any;
    return translations[key] || key;
  }
};

export const ForgotPasswordScreen = () => {
  const navigate = useNavigate();
  const [errorState, setErrorState] = useState('');

  const handleSendPasswordResetEmail = (values: { email: string }) => {
    const { email } = values;

    sendPasswordResetEmail(auth, email)
      .then(() => {
        console.log('Success: Password Reset Email sent.');
        navigate('/login');
        window.alert(`Liga enviada por correo. \n Por favor revisa en: \n -Bandeja de entrada \n -Correo no deseado \n- Spam \n- Junk`);
      })
      .catch(error => setErrorState(error.message));
  };

  const containerStyle: CSSProperties = {
    flex: 1,
    backgroundColor: Colors.white,
    paddingLeft: '12px',
    paddingRight: '12px',
    minHeight: '100vh',
  };

  const innerContainerStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
  };

  const screenTitleStyle: CSSProperties = {
    fontSize: '32px',
    fontWeight: '700',
    color: Colors.black,
    paddingTop: '20px',
  };

  const buttonStyle: CSSProperties = {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '8px',
    backgroundColor: Colors.brown_border,
    padding: '10px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
  };

  const buttonTextStyle: CSSProperties = {
    fontSize: '20px',
    color: Colors.white,
    fontWeight: '700',
  };

  const borderlessButtonContainerStyle: CSSProperties = {
    marginTop: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <View style={containerStyle}>
      <View style={innerContainerStyle}>
        <h1 style={screenTitleStyle}>{i18n.t('resetYourPassword')}</h1>
      </View>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={passwordResetSchema}
        onSubmit={values => handleSendPasswordResetEmail(values)}
      >
        {({
          values,
          touched,
          errors,
          handleChange,
          handleSubmit,
          handleBlur
        }) => (
          <>
            <TextInput
              name='email'
              leftIconName='email'
              placeholder={i18n.t('mail')}
              autoCapitalize='none'
              type='email'
              value={values.email}
              onChange={handleChange('email')}
              onBlur={handleBlur('email')}
            />
            <FormErrorMessage error={errors.email} visible={touched.email} />
            {errorState !== '' ? (
              <FormErrorMessage error={errorState} visible={true} />
            ) : null}
            <button style={buttonStyle} onClick={() => handleSubmit()}>
              <span style={buttonTextStyle}>{i18n.t('sendResetMail')}</span>
            </button>
          </>
        )}
      </Formik>
      <Button
        style={borderlessButtonContainerStyle}
        borderless
        title={i18n.t('goBackToLogin')}
        onPress={() => navigate('/login')}
      />
    </View>
  );
};
